import React from 'react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';

import { i18n } from '../../widgetMacroI18n.ts';
import type { EmbedDescriptor } from '../../widgetMacroTypes.ts';

const styles = cssMap({
	root: {
		borderWidth: 0,
		borderStyle: 'none',
	},
});

type Props = {
	descriptor: EmbedDescriptor;
};

/**
 * Renders the legacy YouTube iframe.
 *
 * Mirrors the legacy `youtube.vm` template:
 *  - `type="text/html"` — matches the legacy template attribute.
 *  - `allowTransparency` — present on all widget iframe variants (§6.2).
 *  - Width/height are forwarded as attributes (already `px`-suffixed by `youtubeMatcher`).
 */
export const YoutubeIframeEmbed = ({ descriptor }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const title = formatMessage(i18n.embedTitle, { provider: descriptor.provider });

	return (
		<Box xcss={styles.root} testId="widget-macro-youtube-wrapper">
			<iframe
				title={title}
				data-testid="widget-macro-youtube-iframe"
				src={descriptor.embedUrl}
				width={descriptor.width || undefined}
				height={descriptor.height || undefined}
				frameBorder={0}
				allowTransparency
			/>
		</Box>
	);
};
